import { loader } from 'graphql.macro'

export default function wastepayTransactionQuery ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const wastepayTransactionSchema = loader('./wastepayTransaction.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(wastepayTransactionSchema, {
    transactionId: variables.transactionId
  })
}
